type ExtractAgentIdFromPathParams = {
    pathname: string;
};

/**
 * Extract agentId from URL path.
 * Matches /agents/:agentId/... pattern
 */
const extractAgentIdFromPath = ({ pathname }: ExtractAgentIdFromPathParams): string | null => {
    const match = pathname.match(/^\/agents\/([^/]+)/);
    return match ? match[1] : null;
};

export default extractAgentIdFromPath;
